import { useState, useEffect, useCallback } from 'react';
import { adminStatsAPI } from '../../services/adminApi';

export const useSystemOverview = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOverview = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await adminStatsAPI.getSystemOverview();
      setData(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch system overview');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOverview();
  }, [fetchOverview]);

  return { data, loading, error, refetch: fetchOverview };
};

export const useUserStats = (timeRange = '30d') => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await adminStatsAPI.getUserStats(timeRange);
        setData(response.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch user stats');
      } finally {
        setLoading(false);
      }
    };

    fetchUserStats();
  }, [timeRange]);

  return { data, loading, error };
};

export const useAPIStats = (timeRange = '24h') => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAPIStats = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await adminStatsAPI.getAPIStats(timeRange);
        setData(response.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch API stats');
      } finally {
        setLoading(false);
      }
    };

    fetchAPIStats();
  }, [timeRange]);

  return { data, loading, error };
};

export const usePlatformStats = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPlatformStats = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await adminStatsAPI.getPlatformStats();
      setData(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch platform stats');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPlatformStats();
  }, [fetchPlatformStats]);

  return { data, loading, error, refetch: fetchPlatformStats };
};
